import { type TabItem } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import {
    InfoTabIcon,
    SecurityNotificationTabIcon,
} from '@components/_atoms/icons';
import TabbedInfoCard from '@components/_molecules/InfoCards/TabbedInfoCard';
import { type ComponentProps } from '../models/ComponentProps';
import { ComponentDetailsTab } from './components/ComponentDetailsTab';
import { NotificationsDetailsTab } from './components/NotificationsDetailsTab';

export function ComponentInfoCard({ component }: ComponentProps): ReactNode {
    const tabItems: TabItem[] = [
        {
            name: 'Details',
            icon: <InfoTabIcon />,
            content: <ComponentDetailsTab component={component} />,
        },
        {
            name: 'Notifications',
            icon: <SecurityNotificationTabIcon />,
            content: <NotificationsDetailsTab component={component} />,
        },
    ];

    return <TabbedInfoCard tabItems={tabItems} />;
}
